export default __webpack_public_path__ + "static/media/(9).8d41cd4e.jpeg";